export default __webpack_public_path__ + "static/media/digi1.7aeacbab.png";